import type { NotificationDto } from "@synthesis/shared-services/notification/external/types";

import type { ApplicationNotification, NotificationParams } from "./notifications-panel.types";

const EVENT_TEXT: Record<NonNullable<NotificationDto["eventType"]>, { title: string; description: string }> = {
  APPLICATION_SUBMITTED: { title: "Заявка подана", description: "Подана новая заявка на получение технических условий." },
  APPROVERS_ASSIGNED: { title: "Назначены согласующие", description: "По заявке назначены согласующие." },
  APPROVER_REVIEWED: { title: "Согласующий рассмотрел заявку", description: "Согласующий завершил рассмотрение заявки." },
  FINAL_DECISION: { title: "Принято итоговое решение", description: "По заявке принято итоговое решение." },
  EMAIL_CHANGE_OLD_EMAIL_NOTICE: { title: "Смена адреса электронной почты", description: "Запрошено изменение адреса электронной почты." },
  EMAIL_CHANGE_CONFIRMATION: {
    title: "Подтверждение смены адреса электронной почты",
    description: "Требуется подтверждение нового адреса электронной почты.",
  },
  EMAIL_CHANGED: { title: "Адрес электронной почты изменён", description: "Адрес электронной почты вашей учётной записи изменён." },
};

export const mapNotificationDto = (dto: NotificationDto, index: number): ApplicationNotification => {
  const eventType = dto.eventType ?? "UNKNOWN";
  const text = dto.eventType ? EVENT_TEXT[dto.eventType] : undefined;
  const link = dto.requestId ? `/applications/${encodeURIComponent(dto.requestId)}` : undefined;
  const params: NotificationParams = { ...dto.params, ...(dto.requestId ? { requestId: dto.requestId } : {}) };

  return {
    actions: link ? [{ payload: link, title: "Открыть заявку", type: "link" }] : [],
    createdAt: dto.createdAt ?? undefined,
    description: params.applicationNumber ? `Заявка №${params.applicationNumber}` : (text?.description ?? "Получено новое уведомление."),
    id: dto.id ?? `notification-${index}`,
    isNew: !dto.read,
    link,
    name: eventType,
    notificationSourceType: eventType,
    requestId: dto.requestId ?? undefined,
    params,
    title: text?.title ?? "Уведомление",
  };
};

export const mapNotifications = (items: NotificationDto[] | undefined): ApplicationNotification[] => (items ?? []).map(mapNotificationDto);
